import { getEnvVar } from "common/utilities/ generic";
import BaseRestApi from "../BaseRestApi";

const preparePath = () => getEnvVar("REACT_APP_COGNITO_API");

const _prepareTokenHeader = () => {
    return {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Basic ${getEnvVar("REACT_APP_COGNITO_TOKEN")}`,
        },
    };
};

const _prepareParams = () => {
    return (
        "grant_type=client_credentials"
    );
};


class CognitoApi extends BaseRestApi.Api {
    constructor() {
        super({
            getPath: preparePath,
            method: BaseRestApi.methods.POST,
            getRequestConfig: () => _prepareTokenHeader(),
            getRequestPayload: () => _prepareParams(),
        });
    }
}

export default new CognitoApi();
